export const TIPO_TITULO_HEADER = 'TIPO';
export const NUMERO_TITULO_HEADER = 'NÚMERO';
export const VENCIMENTO_TITULO_HEADER = 'VENCIMENTO';
export const VALOR_TITULO_HEADER = 'VALOR';
